module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Avengers-Infinity-Wars.c7f9296.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Avengers-Infinity-Wars.jpg
// module id = hvOk
// module chunks = 0